import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Website } from '../../models/interfaces/website';

@Component({
  selector: 'app-our-works',
  templateUrl: './our-works.component.html',
  styleUrls: ['./our-works.component.css']
})
export class OurWorksComponent implements OnInit, OnChanges {
  @Input() data!: any;
  websites: Website[] = [];
  selectedWebsite!: Website;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.websites = changes['data'].currentValue.websites;
      this.selectedWebsite = this.websites[0];
    }
  }

  ngOnInit(): void {
  }
  
  selectWebsite(site: Website) {
    this.selectedWebsite = site;
  }

  trackById(index: number, site: Website): number {
    return site.id;
  }
}
